<div class="commission-import-row-details-view-container" *ngIf="commissionImportRowObject" fxLayout="column" fxLayoutGap="15px" >
  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + commissionImportRowObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="commissionImportRowObject.status?.name">
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <button
      [disabled]="!(userPermissions | async).settlement.write
      || commissionImportRowObject.settlement?.status?.key === COMMISSION_SETTLEMENT_STATUS_CLOSED
      || commissionImportRowObject.settlement?.status?.key === COMMISSION_SETTLEMENT_STATUS_SETTLED"
      (click)="modify()" mat-stroked-button color="primary"
    ><mat-icon>create</mat-icon> <span> Edytuj</span></button>
  </div>

  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane polisy</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="TU" [value]="commissionImportRowObject.insuranceCompany?.name"
                          [link]="['/tu/szczegoly', commissionImportRowObject.insuranceCompany?.id]"></app-detail>

              <app-detail fxFlex="50" header="Numer polisy" [value]="commissionImportRowObject.policyNumber"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Numer poprzedniej polisy" [value]="commissionImportRowObject.previousPolicyNumber"></app-detail>

              <app-detail fxFlex="50" header="Numer dokumentu" [value]="commissionImportRowObject.documentNumber"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Numer umowy ubezpieczenia" [value]="commissionImportRowObject.policyContractNumber"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Data zawarcia" [value]="commissionImportRowObject.concludeDate | date:'y-MM-dd'"></app-detail>

              <app-detail fxFlex="50" header="Liczba rat" [value]="commissionImportRowObject.installmentsCount?.toString()"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Data rozpoczęcia ochrony" [value]="commissionImportRowObject.protectionStartsAt | date:'y-MM-dd'"></app-detail>

              <app-detail fxFlex="50" header="Data końca ochrony" [value]="commissionImportRowObject.protectionEndsAt | date:'y-MM-dd'"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Metoda płatności" [value]="commissionImportRowObject.paymentMethod"></app-detail>

              <app-detail fxFlex="50" header="Typ">
                {{commissionImportRowObject?.policyType?.name}}
              </app-detail>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane prowizji</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Miesiąc rozliczeniowy" [value]="commissionImportRowObject.billingMonth"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Ryzyko ASF" [value]="commissionImportRowObject.risk?.name"></app-detail>

              <app-detail fxFlex="50" header="Riders" [value]="commissionImportRowObject.riders?.join(', ')"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Kod grupy" [value]="commissionImportRowObject.riskPack"></app-detail>

              <app-detail fxFlex="50" header="Nazwa grupy" [value]="commissionImportRowObject.riskPackName"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Kod ryzyka" [value]="commissionImportRowObject.riskCode"></app-detail>

              <app-detail fxFlex="50" header="Nazwa ryzyka" [value]="commissionImportRowObject.riskName"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Inkaso">{{commissionImportRowObject.collection | number:'1.2-2'}} zł</app-detail>

              <app-detail fxFlex="50" header="Prowizja">
                {{(commissionImportRowObject.commission != 0 ? commissionImportRowObject.commission : 0) | number:'1.2-2'}} zł
              </app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Stawka % TU (z pliku)">
                <ng-container *ngIf="commissionImportRowObject.importRate !== null">
                  {{commissionImportRowObject.importRate | number:'1.2-2'}}%
                </ng-container>
              </app-detail>

              <app-detail fxFlex="50" header="Stawka % TU (wyliczona)">
                {{(commissionImportRowObject.rate != 0 ? commissionImportRowObject.rate : 0) | number:'1.2-2'}}%
              </app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Stawka % Partner">
                <ng-container *ngIf="commissionImportRowObject.ratePaid !== null">
                  {{commissionImportRowObject.ratePaid | number:'1.2-2'}}%
                </ng-container>
              </app-detail>

              <app-detail fxFlex="50" header="Prowizja Partner">
                <ng-container *ngIf="commissionImportRowObject.commissionPaid !== null">
                  {{commissionImportRowObject.commissionPaid | number:'1.2-2'}} zł
                </ng-container>
              </app-detail>
            </div>

            <div fxLayout="row" *ngIf="commissionImportRowObject.settlement">
              <app-detail fxFlex="100" header="Rozliczenie" [link]="['/rozliczenia/szczegoly', commissionImportRowObject.settlement?.uuid]">
                {{commissionImportRowObject.settlement.billingMonth}} -
                <ng-container *ngIf="commissionImportRowObject.settlement.partner">
                  {{commissionImportRowObject.settlement.partner?.shortName}}
                </ng-container>

                <ng-container *ngIf="commissionImportRowObject.settlement.ofwca">
                  {{commissionImportRowObject.settlement.ofwca.fullName}}
                </ng-container>

              </app-detail>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="commissionImportRowObject.manuallySet.includes(RATE_THRESHOLD_40) || commissionImportRowObject.manuallySet.includes(RATE_THRESHOLD_10)">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>PZU</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Próg">
                <span *ngIf="commissionImportRowObject.manuallySet.includes(RATE_THRESHOLD_40)"> Próg pierwszy - 40%</span>
                <span *ngIf="commissionImportRowObject.manuallySet.includes(RATE_THRESHOLD_10)"> Próg drugi - 10%</span>
              </app-detail>

              <app-detail fxFlex="50" header="Stawka % TU przed">
                {{calculateRateThreshold(commissionImportRowObject, commissionImportRowObject.importRate) | number:'1.2-2'}}%
              </app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Stawka % Partner przed">
                {{calculateRateThreshold(commissionImportRowObject, commissionImportRowObject.ratePaid) | number:'1.2-2'}}%
              </app-detail>
              <app-detail fxFlex="50" header="Prowizja Partner przed">
                {{calculateRateThreshold(commissionImportRowObject, commissionImportRowObject.commissionPaid) | number:'1.2-2'}} zł
              </app-detail>
            </div>
          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="commissionImportRowObject.zipped">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Suwak</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Stawka bez suwaka">
                {{(commissionImportRowObject.rateWithoutZip != 0 ? commissionImportRowObject.rateWithoutZip : 0) | number:'1.2-2'}}%
              </app-detail>

              <app-detail fxFlex="50" header="Potrącona stawka">
                {{(commissionImportRowObject.zipValue != 0 ? commissionImportRowObject.zipValue : 0) | number:'1.2-2'}}%
              </app-detail>
            </div>

          </mat-card>
        </div>
      </div>


      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dodatkowe informacje</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div [fxFlex]="commissionImportRowObject.position ? 50 : 100">
              <app-detail fxFlex="100" header="Data importu" [value]="commissionImportRowObject.createdAt | date:'y-MM-dd'"></app-detail>
              </div>
                <div fxFlex="50" *ngIf="commissionImportRowObject.position">
                <app-detail fxFlex="100" header="Stanowisko" [value]="commissionImportRowObject.position"></app-detail>
                </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Nazwa/numer pośrednika" [value]="commissionImportRowObject.companyNumber"></app-detail>

              <app-detail fxFlex="50" header="Firma" [value]="commissionImportRowObject.company?.name"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="100" header="Uwagi">
                {{commissionImportRowObject.note}}
              </app-detail>
            </div>

            <div fxLayout="row">
              <app-detail header="Ręczne modyfikacje" fxFlex="100">
                <mat-chip-list>
                  <ng-container *ngFor="let manuallySet of commissionImportRowObject.manuallySet">
                    <ng-container [ngSwitch]="manuallySet">
                      <mat-chip color="accent" selected *ngSwitchCase="'risk'">Ryzyko ASF</mat-chip>
                      <mat-chip color="accent" selected *ngSwitchCase="'risk_pack'">Kod grupy</mat-chip>
                      <mat-chip color="accent" selected *ngSwitchCase="'policy_type'">Typ polisy</mat-chip>
                      <mat-chip color="accent" selected *ngSwitchCase="'relations'">Relacje</mat-chip>
                      <mat-chip color="accent" selected *ngSwitchCase="'rate_paid'">Stawka % Partner</mat-chip>
                      <mat-chip color="accent" selected *ngSwitchCase="'proportional_commission'">Proporcjonalna prowizja</mat-chip>
                      <mat-chip color="accent" selected *ngSwitchCase="'commission_paid'">Prowizja zł Partnera</mat-chip>
                      <mat-chip color="accent" selected *ngSwitchCase="'rejected'">Odrzucona</mat-chip>
                      <mat-chip color="accent" selected *ngSwitchCase="'collection'">Inkaso</mat-chip>
                      <mat-chip color="accent" selected *ngSwitchCase="'block'">Blokada zmian na polisach</mat-chip>
                    </ng-container>
                  </ng-container>
                </mat-chip-list>
              </app-detail>
            </div>

          </mat-card>
        </div>
      </div>
    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Relacje</h3>
            </div>

            <div fxLayout="row" *ngIf="commissionImportRowObject.commissionRedirection">
              <app-detail
                fxFlex="100" header="Przepięcie polisy"
                [link]="commissionImportRowObject.commissionRedirection ? ['/przepiecia-polis/szczegoly', commissionImportRowObject.commissionRedirection.uuid] : undefined"
              >
                <ng-container *ngIf="commissionImportRowObject.commissionRedirection.policyNumber">
                  {{commissionImportRowObject.commissionRedirection.insuranceCompany.name}},
                  nr: <span class="extra-letter-spacing">{{commissionImportRowObject.commissionRedirection.policyNumber}}</span>
                </ng-container>
                <ng-container *ngIf="!commissionImportRowObject.commissionRedirection.policyNumber">
                  {{commissionImportRowObject.commissionRedirection.insuranceCompany.name}},
                  nazwa klienta: <span class="extra-letter-spacing">{{commissionImportRowObject.commissionRedirection.customerName}}</span>
                </ng-container>
              </app-detail>
            </div>
            <div fxLayout="row" *ngIf="commissionImportRowObject.commissionUpdatePackage">
              <app-detail
                fxFlex="100"
                header="Konfigurator polisy"
              >
                <ng-container *ngIf="commissionImportRowObject.commissionUpdatePackage.id">
                  <a class="default-link"
                     [href]="'/konfigurator/szczegoly/' + commissionImportRowObject.commissionUpdatePackage.uuid"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    nr: {{ commissionImportRowObject.commissionUpdatePackage.id }}
                    z dnia: {{
                      commissionImportRowObject.commissionUpdatePackage.createdAt | date: 'y-MM-dd'
                    }}
                  </a>
                </ng-container>
              </app-detail>

            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="OFWCA" [value]="commissionImportRowObject.ofwca?.fullName"
                          [link]="commissionImportRowObject.ofwca ? ['/ofwca/szczegoly', commissionImportRowObject.ofwca?.uuid] : undefined"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Umowa"
                          [value]="commissionImportRowObject.contract ? (commissionImportRowObject.contract.type.name + ' (nr: ' + commissionImportRowObject.contract.number + '), '
                          + commissionImportRowObject.contract.status.name) : undefined"
                          [link]="commissionImportRowObject.contract ? ['/umowy/szczegoly', commissionImportRowObject.contract.uuid] : undefined">
              </app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Partner"
                          [value]="commissionImportRowObject.partner?.shortName"
                          [link]="commissionImportRowObject.partner ? ['/partnerzy/szczegoly', commissionImportRowObject.partner?.uuid] : undefined">
              </app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Placówka" [value]="commissionImportRowObject.partnerFacility?.address?.searchString"
                            [link]="commissionImportRowObject.partnerFacility ? ['/placowki/szczegoly', commissionImportRowObject.partnerFacility?.address?.uuid] : undefined"></app-detail>
              </div>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <app-detail header="Rejestracja" [value]="commissionImportRowObject.registration ? (commissionImportRowObject.registration.insuranceCompany.name
                                          + ' ' + commissionImportRowObject?.ofwca?.fullName) : undefined"
                            [link]="commissionImportRowObject.registration ? ['/rejestracje/szczegoly', commissionImportRowObject.registration.uuid] : undefined">
                </app-detail>
              </div>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Regionalny majątek (OFWCA)" [value]="commissionImportRowObject.ofwca?.assetsRegional?.fullName"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Regionalny majątek (Partner)" [value]="commissionImportRowObject.partner?.assetsRegional?.fullName"></app-detail>

              <app-detail fxFlex="50" header="Regionalny życie (Partner)" [value]="commissionImportRowObject.partner?.assetsRegional?.fullName"></app-detail>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane OFWCA</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Imię i nazwisko" [value]="commissionImportRowObject.ofwcaFullName"></app-detail>

              <app-detail fxFlex="50" header="PESEL" [value]="commissionImportRowObject.ofwcaPesel"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Typ identyfikatora" [value]="commissionImportRowObject.ofwcaIdType?.name"></app-detail>

              <app-detail fxFlex="50" header="Identyfikator" [value]="commissionImportRowObject.ofwcaIdNumber"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="commissionImportRowObject.altOfwcaIdType">
              <app-detail fxFlex="100" header="Alternatywny identyfikator">
                {{commissionImportRowObject.altInsuranceCompany?.name}}, {{commissionImportRowObject.altOfwcaIdType?.name}}: {{commissionImportRowObject.altOfwcaIdNumber}}
              </app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="commissionImportRowObject.secAltOfwcaIdType">
              <app-detail fxFlex="100" header="Alternatywny identyfikator">
                {{commissionImportRowObject.secAltInsuranceCompany?.name}}, {{commissionImportRowObject.secAltOfwcaIdType?.name}}: {{commissionImportRowObject.secAltOfwcaIdNumber}}
              </app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="RAU" [value]="commissionImportRowObject.ofwcaRau"></app-detail>

              <app-detail fxFlex="50" header="Kod zniżkowy Chronie.pl" [value]="commissionImportRowObject.ofwcaDiscountCode"></app-detail>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane klienta</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Imię i nazwisko" [value]="commissionImportRowObject.customerName"></app-detail>

              <app-detail fxFlex="50" header="PESEL" [value]="commissionImportRowObject.customerPesel"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="NIP" [value]="commissionImportRowObject.customerTaxNumber"></app-detail>

              <app-detail fxFlex="50" header="REGON" [value]="commissionImportRowObject.customerRegon"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Email" [value]="commissionImportRowObject.customerEmail"></app-detail>

              <app-detail fxFlex="50" header="Telefon" [value]="commissionImportRowObject.customerPhone"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="100" header="Adres" [value]="commissionImportRowObject.customerAddress"></app-detail>
            </div>

          </mat-card>
        </div>
      </div>
    </div>

  </div>
</div>
